import _ from 'lodash';
import Service from './abstract';
import productsService from './products';
import currenciesService from './currencies';

const defaultWith = 'attributes,attributes.attribute,wallet,product,product.type,product.attributes,product.attributes.attribute,currency,currency.attributes,currency.attributes.attribute';
const defaultOptionsFind = {
    order: 'created_at-DESC',
    with: defaultWith
};
const defaultAccounts = {
    with: 'wallet,attributes,attributes.attribute,product,product.type,product.attributes,product.attributes.attribute,currency,currency.attributes,currency.attributes.attribute',
    order: 'created_at-DESC',
};
const defaultAlicuotas = {
    with: 'account,aliquot,aliquots.tax,aliquots.tax.type'
};
const defaultAlicuotasById = {
    with: 'aliquots,aliquots.tax,aliquots.tax.type'
};
class Accounts extends Service {
    constructor () {
        super('accounts');
    }

    get defaultOptionsFind () {
        return _.merge({}, super.defaultOptionsFind, defaultOptionsFind);
    }

    getAccountsList (options = {}) {
        return super.get({
            url: `${this.basePath}/accounts/cvu/view`,
            qs: _.defaultsDeep({}, options, defaultAccounts, { paginationActive: true })
        });
    }

    getWallets (options = {}) {
        const opts = {
            url: `${this.basePath}/wallets`,
            qs: _.defaultsDeep({}, options)
        };
        return super.get(opts);
    }

    getProperties (options = {}) {
        const opts = {
            url: `${this.basePath}/accounts/attributes`,
            qs: _.defaultsDeep({}, options)
        };
        return super.get(opts);
    }

    getCvuAlias (data) {
        const opts = {
            url: `${this.basePath}/accounts/cvu/${data}`,
        };
        return super.get(opts);
    }

    getAlicuotas (options = {}) {
        const opts = {
            url: `${this.basePath}/accounts/aliquots`,
            qs: _.defaultsDeep({}, options, defaultAlicuotas)
        };

        return super.get(opts);
    }

    getAlicuotasById (options = {}, id) {
        const opts = {
            url: `${this.basePath}/accounts/${id}`,
            qs: _.defaultsDeep({}, options, defaultAlicuotasById)
        };

        return super.get(opts);
    }

    getFraudById (options = {}, id) {
        const opts = {
            url: `${this.basePath}/accounts/${id}/fraudcontrol/rules`,
            qs: { with: 'rule' }
        };

        return super.get(opts);
    }

    normalize (account) {
        if (_.isNil(account)) {
            return account;
        }

        // Prepare default properties
        account = super.normalize(account);

        // Prepare product
        if (account.product) {
            account.product = productsService.normalize(account.product);
        }

        // Prepare currency
        if (account.currency) {
            account.currency = currenciesService.normalize(account.currency);
        }
        return account;
    }
}

export default new Accounts();
